<template>
  <div class="wishlist-row">
    <div class="image-container" @click="visitProductPage(product)">
      <responsive-image :product="this.product"></responsive-image>
      <i
        class="material-icons remove"
        @click.stop="removeProductFromWishlist(product)"
      >
        close
      </i>
      <i v-if="isProductInCart(product)" class="material-icons check cart"
        >check</i
      >
      <i
        v-else
        class="material-icons cart"
        @click="onAddToCartClicked(product)"
      >
        add_shopping_cart
      </i>
    </div>
    <div class="flex-col bottom">
      <div class="flex-col">
        <span class="brand">{{ product.brand }}</span>
        <span class="name">{{ product.name }}</span>
      </div>
      <div class="price-container">
        <span v-if="product.priceSale" class="sale-price">
          {{ product.priceSale | currency }}</span
        >
        <span :class="{ 'price-crossed-out': product.priceSale }">
          {{ product.priceOriginal | currency }}
        </span>
      </div>
      <span>{{ `store.${product.store}` | translate }}</span>
      <div
        class="size-select-container"
        :class="{ visible: addToCartWaitingSize }"
      >
        <product-size-select
          ref="sizeSelect"
          :product="product"
          @search:blur="selectBlurred"
          @input="sizeChosen"
        ></product-size-select>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSizeSelect from "../atoms/product-size-select";
import {
  wishlistMethods,
  cartMethods,
  productImageResizer
} from "../../mixins";
import ResponsiveImage from "../atoms/responsive-image.vue";
export default {
  name: "WishlistRow",
  mixins: [wishlistMethods, cartMethods, productImageResizer],
  components: { ProductSizeSelect, ResponsiveImage },
  props: { product: Object },
  data() {
    return {
      addToCartWaitingSize: false
    };
  },
  methods: {
    sizeChosen() {
      if (this.addToCartWaitingSize && this.product.chosenSize) {
        this.onAddToCartClicked();
        this.addToCartWaitingSize = false;
      }
    },
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    },
    selectBlurred() {
      this.addToCartWaitingSize = false;
    },
    isSizeChosen() {
      if (this.product.chosenSize || this.product.sizes.length === 0) {
        return true;
      } else {
        this.$refs.sizeSelect.select();
        return false;
      }
    },
    onAddToCartClicked() {
      if (this.isSizeChosen()) {
        this.addProductToCart({ ...this.product });
        if (this.$cookies.get("accept-cookie-policy")) {
          this.$gtag.event("productAddedToCart", {
            event_category: "referals",
            event_label: "product",
            value: this.product._id
          });
        }
      } else {
        this.addToCartWaitingSize = true;
      }
    },
    showSimilarClicked() {
      const category = this.product.category;
      this.$router.push({ name: category });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.wishlist-row {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.image-container {
  position: relative;
  margin-bottom: 0.5rem;
  cursor: pointer;

  .material-icons {
    padding: 0.5rem;
    position: absolute;
    font-size: $font-base;

    @media (min-width: $breakpoint-md) {
      font-size: $font-m;
    }

    &.remove {
      left: 0;
      top: 0;
    }

    &.cart {
      bottom: 0;
      right: 0;
      border-radius: 50%;
      box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
      margin: 0.375rem;
      background-color: $brand-white;
    }

    &.check {
      color: $brand-salmon;
      border-radius: 50%;
      box-shadow: 0px 0px 8px rgb(0, 0, 0, 0.25);
      margin: 0.375rem;
    }
  }
}

.flex-col {
  flex: 1;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.size-select-container {
  display: none;

  &.visible {
    display: flex;
  }
}

.bottom {
  span {
    text-overflow: ellipsis;
    font-size: $font-xs;
    margin-bottom: 0.25rem;
  }

  .brand {
    font-family: "Lora";
    font-size: $font-xs;
  }

  .name {
    font-size: $font-xs;
    font-family: "Montserrat-Bold";
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price-container {
    margin-top: -0.25rem;
    margin-bottom: 0.125rem;
  }

  .sale-price {
    font-weight: bold;
    color: $gyra-red;
    margin-right: 0.25rem;
  }
}
</style>
